import React from 'react';
import { Select } from 'antd';
import styles from './index.module.scss';

const BaseSelect = ({ loading, ...props }) => {
  return (
    <Select
      mode="multiple"
      defaultActiveFirstOption={false}
      allowClear
      optionFilterProp="searchtext"
      loading={loading}
      disabled={loading}
      className={styles.select}
      dropdownClassName={styles.selectDropdown}
      {...props}
    />
  );
};

export default BaseSelect;
